import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import * as actions from '../actions/TablaVolcadorasConCerealAsignadoActions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CEREAL_A_VOLCADORA } from '../../../../../config/forms'
import { CircularProgress } from '@material-ui/core'
import { CerealDropdown } from '../../../../Forms/SharedComponents/containers'
import Volcadora from '../../../../../models/volcadora/volcadora'
import Silo from '../../../../../models/silo/silo'

class DialogoVolcadoraUpdate extends Component {
  constructor (props) {
    super(props)
    this.datosVolcadora = []
  }

  async componentDidMount () {
    const { volcadora, change: formChange } = this.props
    this.datosVolcadora = await Volcadora.getVolcadorasCamionesPorVolcadora(volcadora)
    console.log('Datos Volcadora', this.datosVolcadora)
    if (this.datosVolcadora.length > 0) {
      const cereal = (this.datosVolcadora[0].claveCereal) ? this.datosVolcadora[0].claveCereal : 'UNDEF'
      formChange('cereal', cereal)
    }
    const silosValidos = await Silo.getSilosValidosVolcadora(volcadora)
    console.log('Datos Silos', silosValidos)
    this.props.actualizarSilosValidosVolcadora(silosValidos)
    if (this.datosVolcadora.length > 0) {
      const silo = (this.datosVolcadora[0].claveSilo) ? this.datosVolcadora[0].claveSilo : 'NINGUNO'
      formChange('silo', silo)
    }
  }

  renderSilos () {
    const {
      silosValidosVolcadora
    } = this.props
    return [
      (
        <option
          value='NINGUNO'
          key='NINGUNO'
        >
          Ninguno
        </option>
      ),
      ...silosValidosVolcadora.map(silo => {
        return (
          <option
            value={silo.nombreCorto}
            key={silo.nombreCorto}
          >
            {silo.nombre}
          </option>
        )
      })
    ]
  };

  render () {
    const {
      volcadora,
      handleClose,
      handleSubmit
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Modificación de Volcadora</Card.Text>
          </Card.Header>
          {!volcadora && <div style={{ padding: '10% 0', margin: '0 auto' }} >
            <CircularProgress />
          </div> }
          {volcadora &&
            <Card.Body>
              <h3 style={{ textAlign: 'center' }} >Volcadora: <strong>{volcadora}</strong></h3>
              <div className='flex-nowrap container-condicion-recalado' >

                {/* NO SE USA */}
                {/* <Field
                  onChange={this.onSelect}
                  name='silo'
                  label='Silo'
                  disabled={false}
                  component={renderSelectField}
                  placeholder='Elija un silo'>
                  {this.renderSilos()}
                </Field> */}

                <CerealDropdown />
              </div>
            </Card.Body> }
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button>
            <Button style={{ margin: '2%' }} onClick={handleSubmit} >Confirmar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    silosValidosVolcadora: state.volcadora.silosValidosVolcadora
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_CEREAL_A_VOLCADORA,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoVolcadoraUpdate))
